import styled from 'styled-components';

const FormGroup = styled.div`
  margin-bottom: 15px;
`;

export default FormGroup;
